export class MediaIconHelper {

  static getMaterialIcon(mediaType: string): string {
    switch (mediaType) {
      case 'movies': return 'movie';
      case 'seasons': case 'tv': return 'tv';
      case 'music': case 'albums': return 'music_note_2';
      case 'singles': return 'music_note';
      case 'audiobooks': return 'books_movies_and_music';
      case 'ebooks': case 'books': return 'import_contacts';
      case 'apps': return 'mobile_3';
      case 'macapps': case 'mac-apps': return 'laptop_mac';
      default: return 'movie';
    }
  }

}
